// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.company-info {
    background: #F8F9FA;
    border-radius: 10px;
    padding: 20px;
    width: 45%;
    height: 616px;
    min-width: 300px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.company-info-title {
    font-size: 18px;
    font-weight: 700;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    margin-bottom: 10px;
    text-align: left;
    margin-top: 52px;
}

.company-info-expertise-details-style {
    padding: 20px;
}

.company-info-expertise-seperate-details-style {
    padding: 10px; 
}

.company-info-expertise-title {
    margin-top: 42px;
    font-size: 18px;
    font-weight: 700;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
}

.company-info-sub-title-style {
    font-size: 14px;
    font-weight: 500;
    color: #6C757D;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
    max-width: 500px;
}

.company-info-sub-title-black-text-style {
    font-size: 14px;
    font-weight: 500;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
    max-width: 500px;
}

.image-section {
    width: 50%;
    min-width: 300px;
    gap: 20px;
}

.image-section img {
    width: 95%;
    height: 616px;
    border-radius: 10px;
}

.cta-button-main-div {
    width: 40%;
    margin-top: 32px;
    margin-bottom: 60px;
}

.cta-button {
    background-color: #212529;
    color: white;
    font-size: 16px;
    font-weight: 700;
    font-family: "Plus Jakarta Sans", serif;
    padding: 12px 24px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.3s ease-in-out;
    align-self: flex-start; /* Aligns button to the start */
}

.cta-button:hover {
    background-color: #008D62;
}`, "",{"version":3,"sources":["webpack://./src/pages/AboutUs/Component/Story/story.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,uCAAuC;IACvC,sBAAsB,EAAE,+BAA+B;AAC3D;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["\n.company-info {\n    background: #F8F9FA;\n    border-radius: 10px;\n    padding: 20px;\n    width: 45%;\n    height: 616px;\n    min-width: 300px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.company-info-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    margin-bottom: 10px;\n    text-align: left;\n    margin-top: 52px;\n}\n\n.company-info-expertise-details-style {\n    padding: 20px;\n}\n\n.company-info-expertise-seperate-details-style {\n    padding: 10px; \n}\n\n.company-info-expertise-title {\n    margin-top: 42px;\n    font-size: 18px;\n    font-weight: 700;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n}\n\n.company-info-sub-title-style {\n    font-size: 14px;\n    font-weight: 500;\n    color: #6C757D;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n    max-width: 500px;\n}\n\n.company-info-sub-title-black-text-style {\n    font-size: 14px;\n    font-weight: 500;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n    max-width: 500px;\n}\n\n.image-section {\n    width: 50%;\n    min-width: 300px;\n    gap: 20px;\n}\n\n.image-section img {\n    width: 95%;\n    height: 616px;\n    border-radius: 10px;\n}\n\n.cta-button-main-div {\n    width: 40%;\n    margin-top: 32px;\n    margin-bottom: 60px;\n}\n\n.cta-button {\n    background-color: #212529;\n    color: white;\n    font-size: 16px;\n    font-weight: 700;\n    font-family: \"Plus Jakarta Sans\", serif;\n    padding: 12px 24px;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.3s ease-in-out;\n    align-self: flex-start; /* Aligns button to the start */\n}\n\n.cta-button:hover {\n    background-color: #008D62;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
